module.exports = __webpack_public_path__ + "static/kāinga-ac0045372afc2822bd14da2d945b24a4.jpg";